"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const TextEllipsisWithTooltip_1 = require("../../textEllipsis/TextEllipsisWithTooltip");
const useObserver_1 = require("../hooks/useObserver");
const Styled = __importStar(require("../Table.styles"));
const RowItem = (props) => {
    const { tableWidth } = (0, useObserver_1.useObserver)();
    return 'children' in props ? ((0, jsx_runtime_1.jsx)(Styled.TableRowItem, { primary: props.children })) : ((0, jsx_runtime_1.jsx)(Styled.TableRowItem, { children: (0, jsx_runtime_1.jsx)(TextEllipsisWithTooltip_1.TextElipsisWithTooltip, { text: props.text }) }, tableWidth));
};
// eslint-disable-next-line import/no-default-export
exports.default = RowItem;
